import { LRUCache } from "lru-cache";

const FIVE_MINUTES = 1000 * 60 * 5;

// init the cache
export const repoCache = new LRUCache<string, Response>({
  ttl: FIVE_MINUTES,
  max: 5000,
});
